<div class="catalogo" *ngIf="route == 'catalogo-item'">
  <!-- ==== -->

  <!-- ==== -->
  <mat-card
    class="mat-elevation-z6"
    matRipple
    title="Ver información de la variedad"
    (click)="fnItem(cardContent.card_id)"
  >
    <div style="margin-bottom: 0.5em">
      <mat-card-header>
        <img
          *ngIf="cardContent.card_user_image_url"
          mat-card-avatar
          src="{{ cardContent.card_user_image_url }}"
        />
        <img
          *ngIf="!cardContent.card_user_image_url"
          mat-card-avatar
          src="https://wikipapa.org/images/img-no-disponible.jpg"
        />
        <div
          style="
            width: 100%;
            justify-content: right;
            align-items: center;
            display: flex;
          "
        >
          <mat-card-title
            class="text-truncate-line"
            title="{{ cardContent.card_name ? cardContent.card_name : '' }}"
          >
            {{ cardContent.card_name }}
          </mat-card-title>
        </div>
      </mat-card-header>
    </div>

    <mat-divider></mat-divider>

    <mat-card-subtitle
      class="text-truncate"
      title="{{ cardContent.card_value_1 ? cardContent.card_value_1 : '' }}"
    >
      {{ cardContent.card_value_1 }}
    </mat-card-subtitle>

    <div style="margin-bottom: -10px; margin-top: 2em">
      <img
        *ngIf="cardContent.card_image_url"
        mat-card-image
        [src]="cardContent.card_image_url"
        height="190px"
      />

      <img
        *ngIf="!cardContent.card_image_url"
        mat-card-image
        height="190px"
        src="https://wikipapa.org/images/img-no-disponible-large.jpg"
      />
    </div>
  </mat-card>
  <!-- ==== -->

  <!-- ==== -->

  <div
    style="
      text-align: center;
      width: 100%;
      margin-top: -30px;
      z-index: 100;
      position: sticky;
    "
    title="Ver observaciones"
  >
    <button
      style="
        font-size: 13px;
        font-weight: 500;
        background: transparent;
        border: 0px;
        cursor: pointer;
        color: #000;
      "
      (click)="fnGoObsVar(cardContent.card_name)"
    >
      <!-- (click)="fnFilteredObservations()" -->
      <img
        _ngcontent-adq-c359=""
        src="https://wikipapa.org/images/favpng_binoculars.png"
        style="
          height: 14px;
          width: 14px;
          object-fit: cover;
          color: #bbb;
          margin-bottom: -2px;
        "
      />
      {{ cardContent.card_value_2 }} Observaciones
    </button>
  </div>
</div>
<div class="explorer" *ngIf="route == 'observacion'">
  <mat-card
    class="mat-elevation-z6"
    matRipple
    (click)="fnItem(cardContent.card_id)"
  >
    <img
      mat-card-image
      style="height: 300px; object-fit: cover"
      [src]="
        cardContent.card_image_url
          ? cardContent.card_image_url
          : 'https://wikipapa.org/images/img-no-disponible-large.jpg'
      "
    />

    <mat-card-header>
      <mat-card-title
        style="margin-bottom: 9px"
        class="text-truncate"
        title="{{ cardContent.card_name ? cardContent.card_name : '' }}"
        >{{ cardContent.card_name }}
      </mat-card-title>

      <mat-card-subtitle
        class="text-truncate"
        title="{{ cardContent.card_value_1 ? cardContent.card_value_1 : '' }}"
      >
        {{ cardContent.card_value_1 }}
      </mat-card-subtitle>
    </mat-card-header>

    <div style="display: flex; padding: 0px">
      <mat-icon mat-card-avatar style="font-size: 40px; color: #8b2f00"
        >account_circle</mat-icon
      >
      <span style="width: 50%; margin: auto; font-size: 0.95em">{{
        cardContent.card_username
      }}</span>
      <span
        *ngIf="cardContent.card_date"
        style="
          display: flex;
          width: 50%;
          justify-content: end;
          margin: auto;
          font-size: 0.95em;
        "
        title="{{ cardContent.card_date.substring(10, 0) }}"
        >{{ time_ago(cardContent.card_date) }}
      </span>
    </div>
  </mat-card>
</div>
